import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import styled from 'styled-components';

import { rhythm } from "../utils/typography"
import EmojiWrapper from "./EmojiWrapper";

export const List = styled.li`
    textAlign: left;
    line-height:1.25;
    font-weight:${({ isActive }) => isActive ? 600 : 400};;
    margin-left:0px;
    display:block;
    list-style:none;
    color:${({ isActive }) => isActive ? 'var(--color-headingFont)' : 'var(--color-gray2)'};
    position:relative;
    :before{
        content: "";
        diaplay:block;
        width:3px; 
        background:red;
        height:${({ isActive }) => isActive ? '90%' : '0%'};
        position:absolute;
        top:${({ isActive }) => isActive ? '5%' : '50%;'};
        left:-10px;
        border-radius:1.5px;
        background-color:${({ isActive }) => isActive ? 'var(--color-secondary)' : 'var(--color-gray3)'};
        transition : all 200ms;
    }
    :hover:before{
        background-color:var(--color-secondary);
        top:5%;
        height:90%;
    }
    
`


// customHook to keep track of which ID is active       
function useActiveId(itemIds) {
    const [activeId, setActiveId] = useState(``);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveId(entry.target.id);
                    }
                });
            },
            { rootMargin: `0% 0% -50% 0%` }
        );

        itemIds.forEach((id) => {
            observer.observe(document.getElementById(id));
        });

        return () => {
            return itemIds.forEach(id => observer.disconnect(document.getElementById(id)));
        };

    }, [itemIds]);

    return activeId;
}

// get id from headings
function getIds(headings) {
    return headings.map(({ value }) => {
        let transformedHeading = value.split(' ').join('-');
        return transformedHeading;
    })
}


const Toc = ({ headings }) => {
    const idList = getIds(headings);
    const activeId = useActiveId(idList);
    return (
        <div>
            <h4 style={{ textAlign: 'left', color: 'var(--color-primary)' }}>
                <EmojiWrapper emoji="🧾" name="table of content" />Table of content
                </h4>
            <ul style={{ margin: 0 }}>
                {headings.map(({ value }, i) => (
                    <div key={idList[i]} style={{ marginBottom: rhythm(0.25) }} >
                        <Link to={`#${idList[i]}`}>
                            <List isActive={activeId === idList[i]}>
                                <small>
                                    {value}
                                </small>
                            </List>
                        </Link>
                    </div>
                ))}
            </ul>
        </div >
    )
}


export default Toc;
